import React from 'react'
import Expert from 'services/Expert';
import Breed from 'services/Breed';
import { Spinner } from 'components/atoms';
import CollapsibleFieldset from 'components/CollapsibleFieldset';
import { fciGroups } from 'services/constants'
import { handleErrors } from 'services/utils';

export default class ExpertBreeds extends React.Component {
  constructor({ props, match }) {
    super(props);
    this.state = {
      loading: false,
      expert: null,
      breeds: [],
      open: false,
      breedsByGroup: [],
      itemId: match.params.id,
      successSave: false,
    }
    this.mounted = false;
  }

  componentDidMount() {
    this.mounted = true;
    this.loadItem();
  }
  
  componentWillUnmount() {
    this.mounted = false;
  }

  loadItem = () => {
    this.setState({loading: true});
    Expert.get(this.state.itemId).then((expert) => {
      this.setState({ expert });
    }).catch(alert).then(() => this.setState({loading: false}) );
    Breed.query().then(({items: breeds}) => {
      if (this.mounted) {
        const breedsByGroup = fciGroups.map(group => {
          const groupBreeds = breeds.filter(breed => breed.fci_group === group.id)
          return {...group, breeds: groupBreeds}; 
        });
        this.setState( { breeds, breedsByGroup } );
      }
    });
  }

  onCancel = () => {
    this.props.history.goBack()
  }

  groupChanged = ({target}) => {
    let expert = this.state.expert;
    if (target.checked) {
      if (!expert.fci_groups.includes(target.value*1)) {
        expert.fci_groups.push(target.value*1);
      }
    } else {
      const index = expert.fci_groups.indexOf(target.value*1)
      if (index > -1) {
        expert.fci_groups.splice(index, 1);
      }
    }
    this.setState({ expert });
  }

  breedChecked = ({target}) => {
   let expert = this.state.expert;
    if (target.checked) {
      if (!expert.breed_ids.includes(target.value*1)) {
        expert.breed_ids.push(target.value*1);
      }
    } else {
      const index = expert.breed_ids.indexOf(target.value*1)
      if (index > -1) {
        expert.breed_ids.splice(index, 1);
      }
    }
    this.setState({ expert });
  }

  saveChanges = () => {
    let expert = this.state.expert;
    this.setState({ successSave: false, loading:true });
    expert.save().then((item) => {
      if (!this.mounted) return; 
      this.setState({ successSave: true, loading: false });
      this.setState({expert: item});
    }).catch((request) => {
      this.setState({loading: false});
      handleErrors(request);
    });
  }

  render() {
    const {expert, breedsByGroup, open, loading} = this.state;
    if (!expert) return <Spinner />;
    const groupedBreeds = breedsByGroup.map(group => {
      let matched = 0;
      if ( expert.fci_groups.includes(group.id) ) {
        matched = 'вся группа';
      } else {
        if (expert.breed_ids.length) {
          matched = group.breeds.reduce((accum, breed) => {
            return accum + (expert.breed_ids.includes(breed.id) ? 1 : 0);
          }, 0);
        }
      }
      return <CollapsibleFieldset 
         key={group.id}
         title={group.name + ' ( '+group.breeds.length + ' / ' + matched + ' )'} 
         open={open}
         className="m-3">
        <label className="m-1">
          <input type="checkbox"
            value={group.id} 
            checked={expert.fci_groups.includes(group.id)}
            onChange={this.groupChanged} 
          />&nbsp;вся группа
        </label>
        <BreedsList breeds={group.breeds} expert={expert} onChange={this.breedChecked} />
      </CollapsibleFieldset>
    });
    const buttons = (
      <div className="col-md-12 mb-3">
        <button type="button" onClick={this.saveChanges} disabled={this.state.loading} className="btn btn-primary me-2">
          { this.state.loading && <Spinner /> }
          Сохранить
        </button>
        { this.onCancel && 
          <button type="button" onClick={this.onCancel} disabled={this.state.loading} className="btn btn-light">
            { this.state.loading && <Spinner /> }
            Назад
          </button>
        }
      </div>
    );
    return (
      <div className="container">
        <h4>Породы эксперта {expert.name}</h4>
        {loading && <Spinner /> }
        {buttons}
        {groupedBreeds}
        {buttons}
      </div>
    );
  }

}

function BreedsList(props) {
  return (
    <ul className="m-3 list-group">
      {props.breeds.map(breed => (
        <li key={breed.id} className="list-group-item">
          <label>
            <input type="checkbox" 
              value={breed.id}
              checked={props.expert.breed_ids.includes(breed.id)} 
              onChange={props.onChange} 
            />
            &nbsp;{ breed.name }
          </label>
        </li>)
      )}
    </ul>
  );
}